/**
 * Labstep
 *
 * @module grid/NewIndex/coldefs/entity/entity-users
 * @desc Column Definition for entity entity_users
 */

import type {
  EditableCallbackParams,
  ValueGetterParams,
} from 'ag-grid-community';
import { EntityUserActionManage } from 'labstep-web/components/EntityUser/Action/Manage';
import { EntityUserActionManageList } from 'labstep-web/components/EntityUser/Action/Manage/List';
import { ICONS } from 'labstep-web/constants/icons';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import type {
  CellEditorParams,
  CellRendererParams,
} from 'labstep-web/core/DataGrid/types';
import { stopEditingAndFocus } from 'labstep-web/core/DataGrid/utils';
import { GridNewIndexService } from 'labstep-web/grid/NewIndex/services/grid-new-index.service';
import { PostFilterFieldTypes } from 'labstep-web/grid/services/grid-filter.service';
import type {
  EntityUser,
  EntityUserEntities,
} from 'labstep-web/models/entity-user.model';
import { User } from 'labstep-web/models/user.model';

export const colDefEntityEntityUsers = {
  colId: 'entity_users',
  headerName: 'Collaborators',
  headerComponentParams: {
    icon: ICONS.user.secondary,
    postFilterSettings: {
      fieldType: PostFilterFieldTypes.entity,
      path: 'entityUsers.user',
      field: 'guid',
      entityName: User.entityName,
    },
  },
  editable: (params: EditableCallbackParams) =>
    GridNewIndexService.getEditable(params),
  cellStyle: { display: 'flex', alignItems: 'center' },
  valueGetter: (params: ValueGetterParams): number =>
    params.data.entity_users_count,
  valueGetterExport: (params: ValueGetterParams) =>
    params.node?.data && params.node?.data?.entity_users_preview
      ? params.node?.data?.entity_users_preview
          .map(
            (entityUser: EntityUser) => entityUser.user?.name || '',
          )
          .join(', ')
      : '',
  cellRenderer: (params: CellRendererParams<EntityUserEntities>) => {
    if (!params.data) {
      return '';
    }
    return (
      <ParamsStateContextProvider value={{}}>
        <EntityUserActionManageList entity={params.data} />
      </ParamsStateContextProvider>
    );
  },
  cellEditorPopup: true,
  cellEditor: (params: CellEditorParams<EntityUserEntities>) => {
    const { data } = params;
    return (
      <ParamsStateContextProvider value={{}}>
        <EntityUserActionManage
          entity={data}
          viewComponent={null}
          open
          onClose={(): void => stopEditingAndFocus(params)}
        />
      </ParamsStateContextProvider>
    );
  },
};
